import { AutoCompleteOption } from '../../../../../../components/custom-form-controls/auto-complete'
import { StrapiCreate } from '../../../../../../types/strapi/strapi'
import Material from '../../../../../../types/api/material'
import { StrapiSingle } from '../../../../../../types/strapi/strapi'
import { findMaterialDocumentId } from './parse-material-width-value'

type CreateMaterialFn = (
    body: StrapiCreate<Material>
) => Promise<{ data?: StrapiSingle<Material> }>

interface ResolveMaterialParams {
    materialTypeDocId: string
    materialValue: string
    createMaterial: CreateMaterialFn
    materials?: { documentId: string; width: number }[]
    materialOptions?: AutoCompleteOption[]
}

export const resolveMaterialDocumentId = async ({
    materialTypeDocId,
    materialValue,
    createMaterial,
    materials = [],
    materialOptions = [],
}: ResolveMaterialParams): Promise<string | undefined> => {
    const documentId = findMaterialDocumentId(materialValue, materialOptions, materials)

    if (documentId) {
        return documentId
    }

    const width = Number(String(materialValue).trim())

    const res = await createMaterial({
        data: {
            width,
            material_type: { connect: [materialTypeDocId] },
        },
    })

    return res.data?.data.documentId
}
